let sectionTab = document.querySelector('.tabs__wrapper')
let tabButton = sectionTab.querySelectorAll('.tab-button');
let tabContent = sectionTab.querySelectorAll('.tab-content');

tabContent.forEach((content, index) => {
  let dataContent = content.getAttribute('data-tab-content');

  window.addEventListener("resize", ()=> {
    index === 0 ? content.parentNode.style.height = content.clientHeight + 'px' : null
  });
  
  tabButton.forEach(button => {
    let dataButton = button.getAttribute('data-tab-button');

    if (dataButton == dataContent) {
      button.addEventListener('click', () => {

        let activeButton = sectionTab.querySelector('.tab-button.active');
        if (activeButton) {
          activeButton.classList.remove('active')
          activeButton.setAttribute('aria-selected', 'false');
          activeButton.setAttribute('tabindex', '-1');
        }

        let activeContent = sectionTab.querySelector('.tab-content.active');
        if (activeContent) {
          activeContent.classList.remove('active-style')
          setTimeout(() => {
            activeContent.classList.remove('active')
          }, 300);
        }

        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');
        button.setAttribute('tabindex', '0');

        setTimeout(() => {
          content.classList.add('active');
          window.addEventListener("resize", ()=> {
            content.parentNode.style.height = content.clientHeight + 'px';
          });
          content.classList.add('active-style')
        }, 300);
      });
    }
  });
});

// safari useragent detected
let is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (is_safari) {
  sectionTab.classList.add("safari-style");
} else {
    // document.querySelector("body").classList.add("non-safari-style");
}